import { render } from "./OpportunitiesPeriodTable.vue?vue&type=template&id=6be7664a"
import script from "./OpportunitiesPeriodTable.vue?vue&type=script&lang=js"
export * from "./OpportunitiesPeriodTable.vue?vue&type=script&lang=js"

import "./OpportunitiesPeriodTable.vue?vue&type=style&index=0&id=6be7664a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__